enum MutationNames {
  FETCH_CART_REQUESTED = 'FETCH_CART_REQUESTED',
  FETCH_CART_SUCCEEDED = 'FETCH_CART_SUCCEEDED',
  FETCH_CART_FAILED = 'FETCH_CART_FAILED',
  ADD_CARTITEM_REQUESTED = 'ADD_CARTITEM_REQUESTED',
  ADD_CARTITEM_SUCCEEDED = 'ADD_CARTITEM_SUCCEEDED',
  ADD_CARTITEM_FAILED = 'ADD_CARTITEM_FAILED',
  UPDATE_CARTITEM_REQUESTED = 'UPDATE_CARTITEM_REQUESTED',
  UPDATE_CARTITEM_SUCCEEDED = 'UPDATE_CARTITEM_SUCCEEDED',
  UPDATE_CARTITEM_FAILED = 'UPDATE_CARTITEM_FAILED',
  RESET_CART = 'RESET_CART',
  FETCH_CART_APPLICATIONS_REQUESTED = 'FETCH_CART_APPLICATIONS_REQUESTED',
  FETCH_CART_APPLICATIONS_SUCCEEDED = 'FETCH_CART_APPLICATIONS_SUCCEEDED',
  FETCH_CART_APPLICATIONS_FAILED = 'FETCH_CART_APPLICATIONS_FAILED',
  RESET_CART_APPLICATIONS = 'RESET_CART_APPLICATIONS',
  SET_IS_LOADING_CART_APPLICATIONS = 'SET_IS_LOADING_CART_APPLICATIONS',
  INCREMENT_CURRENTLY_SELECTED_APPLICATION = 'INCREMENT_CURRENTLY_SELECTED_APPLICATION',
  DECREMENT_CURRENTLY_SELECTED_APPLICATION = 'DECREMENT_CURRENTLY_SELECTED_APPLICATION',
  APPLICATIONS_COMPLETE = 'APPLICATIONS_COMPLETE',
  RESET_APPLICATIONS_COMPLETE = 'RESET_APPLICATIONS_COMPLETE',
  DELETE_CARTITEM_REQUESTED = 'DELETE_CARTITEM_REQUESTED',
  DELETE_CARTITEM_SUCCEEDED = 'DELETE_CARTITEM_SUCCEEDED',
  DELETE_CARTITEM_FAILED = 'DELETE_CARTITEM_FAILED',
  VALIDATE_AND_SET_CART = 'VALIDATE_AND_SET_CART',
  IS_INITIALIZING_CART_REQUESTED = 'IS_INITIALIZING_CART_REQUESTED',
  IS_INITIALIZING_CART_COMPLETED = 'IS_INITIALIZING_CART_COMPLETED',
  SET_CURRENTLY_SELECTED_APPLICATION_INDEX = 'SET_CURRENTLY_SELECTED_APPLICATION_INDEX',
  COPY_ACTIVE_CART_TO_SUBMITTED_CART = 'COPY_ACTIVE_CART_TO_SUBMITTED_CART',
  RESET_SUBMITTED_CART = 'RESET_SUBMITTED_CART',
  FETCH_STORE_POLICY_REQUESTED = 'FETCH_STORE_POLICY_REQUESTED',
  FETCH_STORE_POLICY_SUCCEEDED = 'FETCH_STORE_POLICY_SUCCEEDED',
  FETCH_STORE_POLICY_FAILED = 'FETCH_STORE_POLICY_FAILED',
  RESET_STORE_POLICY = 'RESET_STORE_POLICY',
  ASSOCIATE_SCHOLAR_REQUESTED = 'ASSOCIATE_SCHOLAR_REQUESTED',
  ASSOCIATE_SCHOLAR_SUCCEEDED = 'ASSOCIATE_SCHOLAR_SUCCEEDED',
  ASSOCIATE_SCHOLAR_FAILED = 'ASSOCIATE_SCHOLAR_FAILED',
  SET_PROMO_CODE = 'SET_PROMO_CODE',
  SET_FETCHING_CART_FOR_PROMO_CODE = 'SET_FETCHING_CART_FOR_PROMO_CODE'
}

export default MutationNames;